import React, { useState, useEffect, useRef } from "react";
import "./MonthlyReport.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import SelectOptions from "../../Components/SelectOptions/SelectOptions";
import Ruler from "../../Components/Ruler/Ruler";
import SizeSelector from "../../Components/SizeSelector/SizeSelector";
import SendBodyPhoto from "../../Components/SendBodyPhoto/SendBodyPhoto";
import useMonthlyAccess from "../../Hooks/useMonthlyAccess";
import sizesData from "./sizesData";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import Alert from "../../Components/Alert/Alert";
import { useBaseUrl } from "../../ApiContext";
import { TiArrowSortedDown } from "react-icons/ti";
import { TiArrowSortedUp } from "react-icons/ti";

export default function MonthlyReport() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const { diets, exercises } = useMonthlyAccess(userToken);
  const planOptionsRef = useRef(null);
  const [weightFromChild, setWeightFromChild] = useState(15);
  const [comment, setComment] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [selectedImages, setSelectedImages] = useState({
    front_pic: "",
    side_pic: "",
    back_pic: "",
  });
  const [imgFiles, setImgFiles] = useState({
    front_pic: null,
    side_pic: null,
    back_pic: null,
  });
  const [bodyMeasurements, setBodyMeasurements] = useState(
    sizesData.reduce((acc, item) => {
      acc[item.label] = "0.0";
      return acc;
    }, {})
  );
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [selectedPlanType, setSelectedPlanType] = useState(null);
  const [planOptions, setPlanOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPlanOptions, setShowPlanOptions] = useState(false)

  const selectTypeHandler = (item) => {
    const selectedTypeOption = planTypeOptions.filter(
      (option) => option.id === item.id
    )[0];
    setSelectedPlanType(selectedTypeOption);
  };

  const handleShowOptions = () => {
    setShowPlanOptions(!showPlanOptions);
  };

  const selectPlanHandler = (item) => {
    const selectedPlanOption = planOptions.filter(
      (option) => option.id === item.id
    )[0];
    setSelectedPlan(selectedPlanOption);
    setShowPlanOptions(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        planOptionsRef.current &&
        !planOptionsRef.current.contains(event.target)
      ) {
        setShowPlanOptions(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [planOptionsRef]);

  useEffect(() => {
    if(planOptions.length > 0) {
      selectPlanHandler(planOptions[0])
    }
  }, [planOptions])

  useEffect(() => {
    if (diets.length > 0 && exercises.length === 0) {
      setPlanTypeOptions([{ id: 1, name: "تغذیه" }]);
    } else if (exercises.length > 0 && diets.length === 0) {
      setPlanTypeOptions([{ id: 1, name: "ورزش" }]);
    } else if (exercises.length > 0 && diets.length > 0) {
      setPlanTypeOptions([
        { id: 1, name: "ورزش" },
        { id: 2, name: "تغذیه" },
      ]);
    }
  }, [diets, exercises]);

  useEffect(() => {
    if (planTypeOptions.length > 0) {
      setSelectedPlanType(planTypeOptions[0]);
      if (planTypeOptions[0].name === "تغذیه") {
        const dietOptions = diets.map((diet) => ({
          id: diet.id,
          name: diet.name,
        }));
        setPlanOptions(dietOptions);
      } else if (planTypeOptions[0].name === "ورزش") {
        const exerciseOptions = exercises.map((exercise) => ({
          id: exercise.id,
          name: exercise.name,
        }));
        setPlanOptions(exerciseOptions);
      }
    }
  }, [planTypeOptions]);

  useEffect(() => {
    if (selectedPlanType && selectedPlanType.name === "تغذیه") {
      const dietOptions = diets.map((diet) => ({
        id: diet.id,
        name: diet.name,
      }));
      setPlanOptions(dietOptions);
    } else if (selectedPlanType && selectedPlanType.name === "ورزش") {
      const exerciseOptions = exercises.map((exercise) => ({
        id: exercise.id,
        name: exercise.name,
      }));
      setPlanOptions(exerciseOptions);
    }
  }, [selectedPlanType]);

  const handleSizeChange = (label, cm, mm) => {
    setBodyMeasurements((prevMeasurements) => {
      return {
        ...prevMeasurements,
        [label]: `${cm}.${mm}`,
      };
    });
  };

  const handleWeightChange = (newWeight) => {
    setWeightFromChild(newWeight);
  };

  const sendReportHandler = async () => {
    const postData = {
      ...bodyMeasurements,
      weight: weightFromChild,
      comment: comment,
      ...selectedImages,
    };
    if (selectedPlanType && selectedPlan) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("در حال ثبت گزارش...");
      try {
        const planType = selectedPlanType && selectedPlanType.name === "تغذیه" ? "diet_plan" : "exercise_plan";
        const response = await Axios.post(
          `${baseUrl}/report/${planType}/${selectedPlan.id}`,
          postData,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response.data);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("گزارش با موفقیت ثبت شد");
      } catch (error) {
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
        console.log("Error during sending monthly report", error);
      }
    }
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">
            گزارش ماهانه تغذیه و ورزش{" "}
            <img
              src="/images/report.svg"
              alt="report icon"
              className="reportIcon"
            />
          </div>
          <div className="monthlyReport scroll">
            {planTypeOptions.length > 0 && (
              <SelectOptions
                optionsData={planTypeOptions}
                onSelect={(item) => selectTypeHandler(item)}
              />
            )}
            {planOptions.length > 0 && (
              <div className="selectOptionsWrapper">
                <div className="selectedOption centeredFlex" onClick={handleShowOptions}>
                {showPlanOptions ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
                  {selectedPlan && selectedPlan.name}
                </div>
                {showPlanOptions && (
                  <div
                    className="dropdownOptions scroll"
                    ref={planOptionsRef}
                  >
                    {planOptions.map((item) => (
                      <div
                        className="otherOption"
                        key={item.id}
                        onClick={() => selectPlanHandler(item)}
                      >
                        {item.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div className="monthlyWeightReport horizontalBorder">
              <h3 className="monthlyReportTitle">وزن</h3>
              <Ruler from="report" onWeightChange={handleWeightChange} />
            </div>
            {sizesData.map((item) => (
              <div
                key={item.id}
                className={`${item.class} horizontalBorder centeredFlex`}
              >
                <h3 className="monthlyReportTitle">{item.title}</h3>
                <SizeSelector
                  label={item.label}
                  onSizeChange={(label, cm, mm) =>
                    handleSizeChange(item.label, cm, mm)
                  }
                />
              </div>
            ))}
            <div className="horizontalBorder">
              <SendBodyPhoto
                selectedImages={selectedImages}
                setSelectedImages={setSelectedImages}
                imgFiles={imgFiles}
                setImgFiles={setImgFiles}
              />
            </div>
            <div className="commentAboutCourse">
              <h3>نظر خود را در مورد این دوره بنویسید</h3>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>
            <button
              className="nextQuestion sendReportBtn"
              onClick={sendReportHandler}
            >
              ارسال گزارش
            </button>
          </div>
          <Alert showAlert={showAlert} alertText={alertText} />
        </div>
      </div>
    </div>
  );
}
